var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvitedTeamAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#2C974A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.1601 23.37C24.0601 23.36 23.9401 23.36 23.8301 23.37C21.4501 23.29 19.5601 21.34 19.5601 18.94C19.5601 16.49 21.5401 14.5 24.0001 14.5C26.4501 14.5 28.4401 16.49 28.4401 18.94C28.4301 21.34 26.5401 23.29 24.1601 23.37Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1602 27.06C16.7402 28.68 16.7402 31.32 19.1602 32.93C21.9102 34.77 26.4202 34.77 29.1702 32.93C31.5902 31.31 31.5902 28.67 29.1702 27.06C26.4302 25.23 21.9202 25.23 19.1602 27.06Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitedTeamAvatar);
export default __webpack_public_path__ + "static/media/invited-team-avatar.83ccc95616734877edb07973e5f68f3b.svg";
export { ForwardRef as ReactComponent };